import React, { createContext, useReducer, useState } from 'react';
// import Context from "./Context";
import AddToCartNo from './AddToCartNo';
export const CardContext = createContext();

const CartContextProvider = (props) => {

    // const data1 = {
    //     shopping: [],
    //     total: 0,
    //     qty: 0
    // };

    const [IsAdding, setIsAdding] = useState(false);

    const [state, dispatch] = useReducer(AddToCartNo, { shopping: [], totalPrice: 0, qty: 0 });
    return (
        <CardContext.Provider value={{ ...state, dispatch, }} >
            {props.children}
        </CardContext.Provider>
    );
};
export default CartContextProvider;